// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"d130bb0e","453":"fa8082ce","506":"51200fa1","968":"d860ff02"}[chunkId] + ".chunk.js";
};